const fmt = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  if (Array.isArray(v)) return `${v.length} item(s)`;
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
};

const label = (k) => k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

function ItemsDiff({ from = [], to = [] }) {
  const key = (it) => it.product_id || it.ingredient_id || it.name;
  const before = new Map((from || []).map((it) => [key(it), it]));
  const after = new Map((to || []).map((it) => [key(it), it]));
  const rows = [];
  for (const [k, a] of after) {
    const b = before.get(k);
    if (!b) rows.push({ name: a.name || k, kind: "added", text: `qty ${fmt(a.quantity ?? a.received_qty)}` });
    else {
      const bq = b.quantity ?? b.received_qty, aq = a.quantity ?? a.received_qty;
      const bp = b.unit_price ?? b.unit_cost, ap = a.unit_price ?? a.unit_cost;
      const parts = [];
      if (Number(bq) !== Number(aq)) parts.push(`qty ${fmt(bq)} → ${fmt(aq)}`);
      if (bp !== undefined && Number(bp) !== Number(ap)) parts.push(`rate ${fmt(bp)} → ${fmt(ap)}`);
      if (parts.length) rows.push({ name: a.name || k, kind: "changed", text: parts.join(", ") });
    }
  }
  for (const [k, b] of before) if (!after.has(k)) rows.push({ name: b.name || k, kind: "removed", text: `qty ${fmt(b.quantity ?? b.received_qty)}` });
  if (!rows.length) return <span className="text-[#8B7355]">line items re-saved, no quantity/rate change</span>;
  return (
    <ul className="space-y-0.5">
      {rows.map((r, i) => (
        <li key={i} className={r.kind === "added" ? "text-emerald-700" : r.kind === "removed" ? "text-red-700" : "text-[#2C1810]"}>
          <span className="uppercase text-[9px] tracking-widest mr-1">{r.kind}</span>{r.name}: {r.text}
        </li>
      ))}
    </ul>
  );
}

export function AuditChanges({ changes }) {
  if (!changes || !Object.keys(changes).length) return null;
  return (
    <div className="bg-[#F7F2E8] border border-[#EAE5D9] rounded-md p-3 text-xs" data-testid="audit-changes">
      <div className="uc-label mb-2">What changed</div>
      <table className="w-full">
        <tbody>
          {Object.entries(changes).map(([k, v]) => (
            <tr key={k} className="align-top">
              <td className="pr-3 py-0.5 font-medium whitespace-nowrap text-[#5C4033]">{label(k)}</td>
              <td className="py-0.5">
                {k === "items"
                  ? <ItemsDiff from={v.from} to={v.to} />
                  : <><span className="text-red-700 line-through">{fmt(v.from)}</span> <span className="mx-1 text-[#8B7355]">→</span> <span className="text-emerald-700 font-medium">{fmt(v.to)}</span></>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
